import React from 'react'
import { Box } from '@chakra-ui/react'

const Hero: React.FC = () => {
  return <Box></Box>
}

export default Hero
